import React from 'react';
import { StyledSideNavList } from '../../styles';

export type SideNavGroupsProps = React.HTMLAttributes<HTMLUListElement>;

/**
 * @purpose Navigation list element (ul) - used for both top-level and nested lists
 */
const SideNavGroups = React.forwardRef<HTMLUListElement, SideNavGroupsProps>((props, ref) => {
  const { className, style, ...otherProps } = props;
  return <StyledSideNavList ref={ref} {...otherProps} />;
});

SideNavGroups.displayName = 'SideNav.Groups';

export default SideNavGroups;
